import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "All Current Rentals", -1)
const _hoisted_2 = { key: 0 }

import { ref } from "vue";

import api from "@virgodev/bazaar/functions/api";
import { UnitInterface } from "@/types/unit";
// const router = useRouter();

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// import { useRouter } from "vue-router";
const units = ref(Array<UnitInterface>());
const errors = ref("");

async function getUnits() {
  errors.value = "";
  const response = await api({
    url: `rentals/`,
  });
  if (response.status == 200) {
    units.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getUnits();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(units.value, (unit) => {
      return (_openBlock(), _createElementBlock("div", {
        key: unit.id + 'unit'
      }, _toDisplayString(unit), 1))
    }), 128)),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})